// AUTO-STUB — à remplacer par l'implémentation réelle
import React from 'react';
export function DDIPanel(_props: any): React.ReactElement | null {
  return null;
}
export default DDIPanel;
